import React from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import Select from "react-select";
import _ from 'lodash';
import imgCamelLogo from '../../assets/images/main-logo-white.png';

import "./CreateCollectionForm.scss";

const CreateCollectionForm = props => {
  const [description, setDescription] = React.useState('');
  const [collectionTitle, setCollectionTitle] = React.useState('');
  const [shareWithValue, setShareWithValue] = React.useState(null);
  const [isMultiSelect, setIsMultiSelect] = React.useState(true);

  const onChangeValue = (type, value) => {
    if (type === 'description') {
      setDescription(value);
    } else if (type === 'collectionTitle') {
      setCollectionTitle(value);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (shareWithValue) {
      const shareWith = Array.isArray(shareWithValue) ? shareWithValue.map(sv => sv.value) : ['ALL'];

      props.onAddCollection({
        title: collectionTitle,
        description,
        sharedBy: _.get(props.settings, 'userInfo.userId', ''),
        sharedWith: shareWith
      });
    } else {
      props.onAddCollection({
        title: collectionTitle,
        description
      });
    }

    props.onClose();
  };

  const handleShareWithChange = value => {
    if (value) {
        if (Array.isArray(value)) {
          const singleValue = value.find(val => val.value === 'ALL' || val.value === null);

          if (singleValue) {
            setIsMultiSelect(false);

            if (singleValue.value) {
              setShareWithValue(value[value.length - 1]);
            } else {
              setShareWithValue(null);
            }
          } else {
            setIsMultiSelect(true);
            setShareWithValue(value);
          }
        } else {
          if (value.value === 'ALL' || value.value === null) {
            setIsMultiSelect(false);

            if (value.value === null) {
              setShareWithValue(null);
            } else {
              setShareWithValue(value);
            }
          } else {
            setIsMultiSelect(true);
            setShareWithValue([value]);
          }
        }
    } else {
      setShareWithValue(null);
    }
  };

  const generateOptions = () => {
    return [
      { value: 'ALL', label: 'All team members' },
      { value: null, label: 'No team members' },
      ..._.get(props.settings, 'users', [])
        .filter(usr => usr.userId !== _.get(props.settings, 'userInfo.userId', ''))
        .map(usr => ({ value: usr.userId, label: usr.name }))
    ];
  };

  return (
    <Form className="create-collection-form" onSubmit={onSubmit}>
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
      </div>
      <div className="p-4">
        <h3>Create new collection</h3>
        <Form.Group as={Row} controlId="collectionTitle">
          <Col sm="9">
            <Form.Control
              type="text"
              className="mr-4"
              placeholder="Collection title"
              value={collectionTitle}
              onChange={(e) => onChangeValue('collectionTitle', e.target.value)}
              required
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="collectionDescription">
          <Col sm="12">
            <Form.Control
              as="textarea"
              rows="4"
              placeholder="Description..."
              value={description}
              onChange={(e) => onChangeValue('description', e.target.value)}
            />
          </Col>
        </Form.Group>
        <div className="flex justify-between mb-3">
          <div className="selector-name">Share with...</div>
          {isMultiSelect ?
            <Select
              className="w-100 select-box funnel-stage"
              classNamePrefix="share_"
              closeOnSelect={true}
              isMulti
              onChange={value => handleShareWithChange(value)}
              options={generateOptions()}
              placeholder="No team members"
              removeSelected={true}
              value={shareWithValue}
            />
            :
            <Select
              className="w-100 select-box funnel-stage"
              classNamePrefix="share_"
              onChange={value => handleShareWithChange(value)}
              options={generateOptions()}
              placeholder="No team members"
              removeSelected={true}
              value={shareWithValue}
            />
          }
        </div>
        <div className="note-text">👉 Collections are private to the team until published as a site</div>
        <Form.Group as={Row} controlId="actionsContainer" >
          <Col className="d-flex justify-content-end actions-container">
            <Button variant="outline-danger" className="mr-2" size="sm" onClick={props.onClose}>CANCEL</Button>
            <Button
              type="submit"
              variant="outline-danger"
              size="sm"
              data-cc-analytics-on='click'
              id="btnCreateNewCollection"
              data-cc-analytics-name='admin-create-new-collection'
              data-cc-analytics-attrs={`collectionTitle:${collectionTitle}`}
            >
              SAVE
            </Button>
          </Col>
        </Form.Group>
      </div>
    </Form>
  )
}

export default CreateCollectionForm;
